import React, { useState } from 'react';
import { MenuIcon, XIcon, ShieldIcon, UserIcon, ClipboardListIcon, AwardIcon, CalendarIcon, MailIcon, HomeIcon } from 'lucide-react';
export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };
  const navItems = [{
    id: 'home',
    label: 'Home',
    icon: <HomeIcon className="w-5 h-5" data-id="element-311" />
  }, {
    id: 'about',
    label: 'Over mij',
    icon: <UserIcon className="w-5 h-5" data-id="element-312" />
  }, {
    id: 'services',
    label: 'Diensten',
    icon: <ShieldIcon className="w-5 h-5" data-id="element-313" />
  }, {
    id: 'qualifications',
    label: 'Kwalificaties',
    icon: <AwardIcon className="w-5 h-5" data-id="element-314" />
  }, {
    id: 'experience',
    label: 'Ervaring',
    icon: <ClipboardListIcon className="w-5 h-5" data-id="element-315" />
  }, {
    id: 'availability',
    label: 'Tarieven',
    icon: <CalendarIcon className="w-5 h-5" data-id="element-316" />
  }, {
    id: 'contact-new',
    label: 'Contact',
    icon: <MailIcon className="w-5 h-5" data-id="element-317" />
  }];
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-gray-900 border-t border-gray-800" data-id="element-318">
      {isOpen && <div className="fixed inset-0 bg-gray-900 bg-opacity-95 z-40 flex flex-col items-center justify-center" data-id="element-319">
          <button onClick={closeMenu} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white" aria-label="Close menu" data-id="element-320">
            <XIcon className="w-6 h-6" data-id="element-321" />
          </button>
          <nav className="flex flex-col items-center gap-4" data-id="element-322">
            {navItems.map(item => <a key={item.id} href={`#${item.id}`} onClick={closeMenu} className="flex items-center gap-3 text-white hover:text-orange-500 transition-colors py-3 px-6 rounded-lg hover:bg-gray-800" data-id="element-323">
                {item.icon}
                <span data-id="element-324">{item.label}</span>
              </a>)}
          </nav>
        </div>}
      {/* Simplified bottom bar */}
      <div className="flex items-center justify-between px-4 py-2 bg-gray-900" data-id="element-325">
        <div className="flex items-center gap-2" data-id="element-326">
          <ShieldIcon className="w-5 h-5 text-orange-500" data-id="element-327" />
          <span className="font-bold text-sm" data-id="element-328">Emre Aksoy</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-329">
          <a href="#contact-new" className="px-3 py-1.5 bg-orange-500 hover:bg-orange-600 text-white text-sm font-medium rounded-md transition-colors flex items-center gap-1" data-id="element-330">
            <MailIcon className="w-4 h-4" data-id="element-331" />
            <span data-id="element-332">Contact</span>
          </a>
          <button onClick={toggleMenu} className="p-1.5 text-gray-400 hover:text-white bg-gray-800 rounded-md" aria-label="Menu" data-id="element-333">
            <MenuIcon className="w-5 h-5" data-id="element-334" />
          </button>
        </div>
      </div>
    </div>;
}